{
  "PROFILE_SETTINGS": {
    "LINK": "Настройки профиля",
    "TITLE": "Настройки профиля",
    "BTN_TEXT": "Обновить профиль",
    "DELETE_AVATAR": "Удалить аватар",
    "AVATAR_DELETE_SUCCESS": "Аватар успешно удалён",
    "AVATAR_DELETE_FAILED": "Произошла ошибка при удалении аватара, пожалуйста, попробуйте снова",
    "UPDATE_SUCCESS": "Ваши данные успешно обновлены",
    "PASSWORD_UPDATE_SUCCESS": "Ваш пароль успешно изменен",
    "AFTER_EMAIL_CHANGED": "Ваш профиль был успешно обновлен, пожалуйста, войдите снова, так как ваши учетные данные были изменены",
    "FORM": {
      "PICTURE": "Фотография профиля",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Изображение для подписи электронной почты",
        "HINT": "Используется в подписях электронной почты. {'{{'}email_signature_picture{'}}'} заменяется URL-адресом этого изображения (а не тегом изображения) — используйте его как источник изображения (атрибут src тега img) в своей подписи или подписи почтового ящика. Если не задано, ничего не вставляется.",
        "DELETE_SUCCESS": "Изображение для подписи электронной почты успешно удалено",
        "DELETE_FAILED": "Произошла ошибка при удалении изображения для подписи электронной почты, попробуйте еще раз"
      },
      "AVATAR": "Изображение",
      "ERROR": "Пожалуйста, исправьте ошибки",
      "REMOVE_IMAGE": "Удалить",
      "UPLOAD_IMAGE": "Загрузить изображение",
      "UPDATE_IMAGE": "Обновить изображение",
      "PROFILE_SECTION": {
        "TITLE": "Профиль",
        "NOTE": "Адрес электронной почты используется для входа."
      },
      "SEND_MESSAGE": {
        "TITLE": "Горячие клавиши для отправки сообщений",
        "NOTE": "Вы можете выбрать горячую клавишу (Enter или Cmd/Ctrl+Enter) в зависимости от ваших предпочтений при написании.",
        "UPDATE_SUCCESS": "Ваши настройки успешно обновлены",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Отправляйте сообщения, нажимая клавишу Enter вместо кнопки отправки."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Отправляйте сообщения, нажимая Cmd/Ctrl + Enter вместо кнопки отправки."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Интерфейс",
        "NOTE": "Настройте внешний вид и оформление вашей панели.",
        "FONT_SIZE": {
          "TITLE": "Размер шрифта",
          "NOTE": "Измените размер текста на всей панели в соответствии с вашими предпочтениями.",
          "UPDATE_SUCCESS": "Настройки шрифта успешно обновлены",
          "UPDATE_ERROR": "Произошла ошибка при обновлении настроек шрифта, пожалуйста, попробуйте ещё раз",
          "OPTIONS": {
            "SMALLER": "Меньше",
            "SMALL": "Маленький",
            "DEFAULT": "По умолчанию",
            "LARGE": "Большой",
            "LARGER": "Крупнее",
            "EXTRA_LARGE": "Очень большой"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Язык панели управления",
          "NOTE": "Переопределяет язык аккаунта только для вашей панели управления. Оставьте пустым, чтобы использовать значение по умолчанию для аккаунта.",
          "USE_ACCOUNT_DEFAULT": "Использовать значение аккаунта по умолчанию",
          "API_SUCCESS": "Язык вашей панели управления успешно обновлён"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Язык сообщений",
          "NOTE": "Выберите, показывать оригинальные сообщения или их переводы",
          "ORIGINAL": "Оригинал",
          "TRANSLATED": "Переведено"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Поведение при вставке",
          "NOTE": "Выберите, как обрабатывать вставленный контент при составлении сообщений",
          "UPDATE_SUCCESS": "Настройки вставки успешно обновлены",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Сохранить всё форматирование",
              "DESCRIPTION": "Сохраняет всё форматирование, включая таблицы, стили и другие элементы HTML, при вставке контента."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Только текст со ссылками",
              "DESCRIPTION": "Преобразует в обычный текст, но сохраняет кликабельные ссылки при вставке контента."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Только обычный текст",
              "DESCRIPTION": "Удаляет всё форматирование и преобразует в обычный текст при вставке контента."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Высота поля ответа",
          "NOTE": "Задайте минимальную высоту поля ответа в процентах от высоты экрана. Применяется только к диалогам по электронной почте.",
          "UPDATE_SUCCESS": "Настройка высоты поля ответа успешно обновлена",
          "PERCENT_LABEL": "Высота (% от высоты экрана)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "По умолчанию",
              "DESCRIPTION": "Поле ответа изначально небольшое и увеличивается по мере ввода текста."
            },
            "CUSTOM": {
              "HEADING": "Пользовательская",
              "DESCRIPTION": "Поле ответа всегда занимает не менее выбранного процента высоты экрана."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Автоматически переходить к следующему диалогу",
        "NOTE": "Автоматически переключаться на следующий открытый диалог после решения текущего",
        "UPDATE_SUCCESS": "Настройка автоматического перехода успешно обновлена"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Личная подпись сообщения",
        "DESCRIPTION": "Создайте уникальную подпись сообщения, которая будет отображаться в конце каждого отправленного вами письма. Вы также можете добавить встроенное изображение.",
        "NOTE": "Создайте уникальную подпись, которая будет отображаться в конце каждого сообщения, отправляемого из любого почтового ящика. Вы также можете добавить встроенное изображение, которое поддерживается в чате, электронной почте и API-почтовых ящиках.",
        "BTN_TEXT": "Сохранить подпись сообщения",
        "API_ERROR": "Не удалось сохранить подпись! Попробуйте снова",
        "API_SUCCESS": "Подпись успешно сохранена",
        "IMAGE_UPLOAD_ERROR": "Не удалось загрузить изображение! Попробуйте снова",
        "IMAGE_UPLOAD_SUCCESS": "Изображение успешно добавлено. Пожалуйста, нажмите сохранить, чтобы сохранить подпись",
        "IMAGE_UPLOAD_SIZE_ERROR": "Размер изображения должен быть меньше {size}МБ"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Подпись сообщения",
        "ERROR": "Подпись сообщения не может быть пустой",
        "PLACEHOLDER": "Вставьте вашу личную подпись сообщения здесь."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Пароль",
        "NOTE": "Обновление пароля сбросит вашу авторизацию на всех устройствах.",
        "BTN_TEXT": "Изменить пароль"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Токен доступа",
        "NOTE": "Этот токен может быть использован, если вы настраиваете интеграцию на основе API",
        "COPY": "Копировать",
        "REGENERATE": "Перевыпустить",
        "REGENERATE_SUCCESS": "Токен доступа успешно перевыпущен. Пожалуйста, обновите все интеграции, использующие старый токен.",
        "REGENERATE_CONFIRM_TITLE": "Перевыпустить токен доступа?",
        "REGENERATE_CONFIRM_MESSAGE": "Это приведёт к аннулированию текущего токена. Все интеграции, использующие старый токен, перестанут работать."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Расширение Chrome",
        "NOTE": "Установите наше расширение Chrome, чтобы получать подробные уведомления о входящих телефонных звонках.",
        "INSTALL_BUTTON": "Установить расширение",
        "ALREADY_INSTALLED": "Расширение установлено"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Аудио уведомления",
        "NOTE": "Включите аудио уведомления на панели управления для новых сообщений и диалогов.",
        "PLAY": "Воспроизвести звук",
        "ALERT_TYPES": {
          "NONE": "Нет",
          "MINE": "Назначено",
          "ALL": "Все",
          "ASSIGNED": "Назначенные диалоги",
          "UNASSIGNED": "Назначенные диалоги",
          "NOTME": "Открытые диалоги, назначенные другим"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Вы не выбрали никаких опций и не будете получать аудио уведомления.",
          "ASSIGNED": "Вы будете получать уведомления о диалогах, назначенных вам.",
          "UNASSIGNED": "Вы будете получать уведомления о любых не назначенных диалогах.",
          "NOTME": "Вы будете получать уведомления о диалогах, назначенных другим.",
          "ASSIGNED+UNASSIGNED": "Вы будете получать уведомления о назначенных вам диалогах и любых неотвеченных.",
          "ASSIGNED+NOTME": "Вы будете получать уведомления о диалогах, назначенных вам и другим, но не о неназначенных.",
          "NOTME+UNASSIGNED": "Вы будете получать уведомления о неотвеченных диалогах и диалогах назначенных другим.",
          "ASSIGNED+NOTME+UNASSIGNED": "Вы будете получать уведомления о всех диалогах."
        },
        "ALERT_TYPE": {
          "TITLE": "События уведомлений для диалогов",
          "NONE": "Нет",
          "ASSIGNED": "Назначенные беседы",
          "ALL_CONVERSATIONS": "Диалоги"
        },
        "DEFAULT_TONE": {
          "TITLE": "Звук уведомления:"
        },
        "CONDITIONS": {
          "TITLE": "Условия уведомления:",
          "CONDITION_ONE": "Отправлять звуковые оповещения только в том случае, если окно браузера не активно",
          "CONDITION_TWO": "Отправлять уведомления каждые 30 сек., пока все назначенные диалоги не будут прочитаны"
        },
        "SOUND_PERMISSION_ERROR": "Автоматическое воспроизведение отключено в вашем браузере. Чтобы автоматически слышать уведомления, включите разрешение на звук в настройках браузера или взаимодействуйте со страницей.",
        "READ_MORE": "Читать далее"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Email Уведомления",
        "NOTE": "Настраивайте email уведомления здесь",
        "CONVERSATION_ASSIGNMENT": "Отправлять email уведомление, когда мне назначен диалог",
        "CONVERSATION_CREATION": "Отправлять email уведомление, когда новый диалог создан",
        "CONVERSATION_MENTION": "Отправлять email уведомление, когда вас упоминают в диалоге",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Отправлять email уведомления при создании нового сообщения в назначенном диалоге",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Отправлять уведомления по электронной почте, когда в диалоге создается новое сообщение",
        "SLA_MISSED_FIRST_RESPONSE": "Отправить уведомление по электронной почте, если диалог не соответствует SLA первого ответа",
        "SLA_MISSED_NEXT_RESPONSE": "Отправить уведомление по электронной почте, если диалог не успел получить следующий ответ SLA",
        "SLA_MISSED_RESOLUTION": "Отправить уведомление по электронной почте, если диалог не соответствует SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Настройки уведомлений",
        "TYPE_TITLE": "Тип уведомления",
        "EMAIL": "Email",
        "PUSH": "Push-уведомления",
        "TYPES": {
          "CONVERSATION_CREATED": "Новый диалог создан",
          "CONVERSATION_ASSIGNED": "Вам назначен диалог",
          "CONVERSATION_MENTION": "Вас упомянули в диалоге",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Новое сообщение создано в назначенном диалоге",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "В назначенном диалоге создано новое сообщение",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Создаётся новое сообщение в диалоге без доступного агента",
          "SLA_MISSED_FIRST_RESPONSE": "Разговор не соответствует SLA по первому ответу",
          "SLA_MISSED_NEXT_RESPONSE": "Диалог не соответствует SLA по следующему ответу",
          "SLA_MISSED_RESOLUTION": "Диалог не соответствует SLA по разрешению"
        },
        "BROWSER_PERMISSION": "Включите push-уведомления для вашего браузера, чтобы вы могли их получать",
        "ALLOW_NOTIFICATION_DURING_CALL": "Разрешить push-уведомления во время звонка",
        "TEST_PUSH": "Тест",
        "TESTING": "Тестирование...",
        "TEST_PUSH_DESCRIPTION": "Отправьте тестовые уведомления, чтобы проверить настройку",
        "TEST_NOTIFICATION_ERROR": "Не удалось отправить тестовое уведомление. Попробуйте ещё раз.",
        "TEST_LOCAL_TITLE": "Тестовое уведомление (локальное)",
        "TEST_LOCAL_BODY": "Это локальное уведомление браузера. Если вы это видите, уведомления браузера работают!"
      },
      "API": {
        "UPDATE_SUCCESS": "Настройки уведомлений сохранены",
        "UPDATE_ERROR": "При сохранении настроек произошла ошибка, пожалуйста, попробуйте еще раз"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push уведомления",
        "NOTE": "Редактируйте настройки push-уведомлений здесь",
        "CONVERSATION_ASSIGNMENT": "Отправлять push уведомление при назначении мне диалога",
        "CONVERSATION_CREATION": "Отправлять push уведомление, когда новый диалог создан",
        "CONVERSATION_MENTION": "Отправлять уведомления при упоминании в разговоре",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Отправлять push уведомления при создании нового сообщения в назначенном диалоге",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Отправлять push-уведомления при создании нового сообщения в участвующем диалоге",
        "HAS_ENABLED_PUSH": "Вы включили push уведомления для этого браузера.",
        "REQUEST_PUSH": "Включить push-уведомления",
        "SLA_MISSED_FIRST_RESPONSE": "Отправить push-уведомление, если диалог не соответствует SLA первого ответа",
        "SLA_MISSED_NEXT_RESPONSE": "Отправить push-уведомление, если диалог не успел получить следующий ответ SLA",
        "SLA_MISSED_RESOLUTION": "Отправить push-уведомление, если диалог не соответствует SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Изображение профиля"
      },
      "NAME": {
        "LABEL": "Ваше имя",
        "ERROR": "Пожалуйста, введите правильное имя",
        "PLACEHOLDER": "Пожалуйста, введите ваше ФИО"
      },
      "DISPLAY_NAME": {
        "LABEL": "Имя, которое будет отображаться",
        "ERROR": "Пожалуйста, введите правильное имя",
        "PLACEHOLDER": "Пожалуйста, введите имя, которое будет отображаться в диалогах"
      },
      "POSITION": {
        "LABEL": "Должность",
        "ERROR": "Пожалуйста, введите корректную должность",
        "PLACEHOLDER": "Пожалуйста, введите вашу должность"
      },
      "CUSTOM_LINE": {
        "LABEL": "Произвольная строка",
        "ERROR": "Пожалуйста, введите корректную произвольную строку",
        "PLACEHOLDER": "Пожалуйста, введите вашу произвольную строку"
      },
      "AVAILABILITY": {
        "LABEL": "Доступность",
        "STATUS": {
          "ONLINE": "В сети",
          "BUSY": "Занят",
          "OFFLINE": "Оффлайн"
        },
        "SET_AVAILABILITY_SUCCESS": "Доступность успешно установлена",
        "SET_AVAILABILITY_ERROR": "Не удалось установить доступность, попробуйте снова"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Формат предпросмотра писем в списке диалогов",
        "NOTE": "Выберите, что отображается в списке диалогов для диалогов из почтовых ящиков",
        "SUBJECT": "Тема",
        "SUBJECT_WITH_NOTE": "Тема и последнее сообщение, если это внутренняя заметка",
        "UPDATE_SUCCESS": "Настройка предпросмотра писем успешно обновлена"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Отключить горячие клавиши",
        "NOTE": "Отключает все горячие клавиши во всём приложении",
        "UPDATE_SUCCESS": "Настройка горячих клавиш успешно обновлена"
      },
      "FOLDER_ORDER": {
        "TITLE": "Порядок папок",
        "NOTE": "Настройте порядок, в котором папки (пользовательские представления) отображаются на боковой панели. Перетащите, чтобы изменить порядок.",
        "NO_FOLDERS": "Пользовательские папки не найдены. Создайте папки, чтобы организовать диалоги."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Настройка боковой панели",
        "NOTE": "Настройте, какие разделы отображаются на боковой панели диалогов.",
        "SAVE_BUTTON": "Сохранить настройки",
        "UPDATE_SUCCESS": "Настройка боковой панели успешно обновлена",
        "UPDATE_ERROR": "Произошла ошибка при обновлении настройки боковой панели, попробуйте ещё раз",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Все диалоги",
          "ALL_CONVERSATIONS_DESC": "Показывать пункт меню «Все диалоги» на боковой панели",
          "INBOX": "Входящие",
          "INBOX_DESC": "Показывать основной раздел «Входящие» с непрочитанными уведомлениями",
          "CONVERSATION_GROUPS": "Упоминания и Неотвеченные",
          "CONVERSATION_GROUPS_DESC": "Показывать группы диалогов «Упоминания» и «Неотвеченные»",
          "FOLDERS": "Папки",
          "FOLDERS_DESC": "Показывать пользовательские представления (папки) для организации диалогов",
          "TEAMS": "Команды",
          "TEAMS_DESC": "Показывать диалоги, отфильтрованные по назначению команде",
          "CHANNELS": "Источники",
          "CHANNELS_DESC": "Показывать диалоги, отфильтрованные по источнику",
          "LABELS": "Категории",
          "LABELS_DESC": "Показывать диалоги, отфильтрованные по категориям"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Настройки телефона",
        "NOTE": "Введите учётные данные для входа в вашу систему PBX.",
        "USERNAME": "Имя пользователя",
        "PASSWORD": "Пароль",
        "SUBMIT": "Сохранить",
        "USERNAME_INVALID": "Имя пользователя может содержать только буквы, цифры и . _ - + — без пробелов и без адреса электронной почты.",
        "API": {
          "USERNAME_INVALID": "Имя пользователя не является допустимым именем пользователя SIP. Используйте только буквы, цифры и . _ - + — без пробелов и без адреса электронной почты.",
          "USERNAME_TAKEN": "Это имя пользователя уже используется другим оператором в этом аккаунте."
        }
      },
      "EMAIL": {
        "LABEL": "Ваш адрес электронной почты",
        "ERROR": "Пожалуйста, введите действительный адрес электронной почты",
        "PLACEHOLDER": "Введите email, который будет отображаться в диалогах"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Текущий пароль",
        "ERROR": "Пожалуйста, введите текущий пароль",
        "PLACEHOLDER": "Пожалуйста, введите текущий пароль"
      },
      "PASSWORD": {
        "LABEL": "Новый пароль",
        "ERROR": "Введите пароль из 6 или более символов",
        "PLACEHOLDER": "Пожалуйста, введите новый пароль"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Подтвердите новый пароль",
        "ERROR": "Подтверждение пароля должно соответствовать паролю",
        "PLACEHOLDER": "Пожалуйста, введите новый пароль еще раз"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Изменить",
    "CHANGE_ACCOUNTS": "Сменить аккаунт",
    "SWITCH_ACCOUNT": "Сменить аккаунт",
    "CONTACT_SUPPORT": "Связаться с поддержкой",
    "REPORT_BUG": "Сообщить об ошибке",
    "SELECTOR_SUBTITLE": "Выберите аккаунт из списка",
    "PROFILE_SETTINGS": "Настройки профиля",
    "KEYBOARD_SHORTCUTS": "Горячие клавиши",
    "APPEARANCE": "Изменить внешний вид",
    "SUPER_ADMIN_CONSOLE": "Консоль супер администратора",
    "DOCS": "Открыть документацию",
    "LOGOUT": "Выйти из системы"
  },
  "BUG_REPORT": {
    "TITLE": "Сообщить об ошибке",
    "DESCRIPTION_LABEL": "Описание проблемы",
    "DESCRIPTION_PLACEHOLDER": "Опишите проблему, с которой вы столкнулись...",
    "SUBMIT": "Отправить отчёт",
    "SUBMITTING": "Отправка...",
    "CANCEL": "Отменить",
    "SUCCESS": "Отчёт об ошибке успешно отправлен. Спасибо!",
    "VALIDATION_ERROR": "Пожалуйста, опишите проблему перед отправкой"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "дней до окончания бесплатного периода.",
    "TRAIL_BUTTON": "Купить",
    "DELETED_USER": "Удаленный пользователь",
    "EMAIL_VERIFICATION_PENDING": "Похоже, что вы еще не подтвердили свой адрес электронной почты. Пожалуйста, проверьте свой почтовый ящик для подтверждения электронной почты.",
    "RESEND_VERIFICATION_MAIL": "Повторно отправить письмо с подтверждением",
    "EMAIL_VERIFICATION_SENT": "Письмо с подтверждением отправлено. Пожалуйста, проверьте свой почтовый ящик.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Аккаунт заблокирован",
      "MESSAGE": "Ваша учетная запись приостановлена. Пожалуйста, обратитесь в службу поддержки для получения дополнительной информации."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Копировать",
      "CODEPEN": "Открыть в CodePen",
      "COPY_SUCCESSFUL": "Код скопирован в буфер обмена"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Показать больше",
      "SHOW_LESS": "Показать меньше"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Скачать",
      "UPLOADING": "Загружаем...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Эта история больше недоступна.",
      "RECORDING_UNAVAILABLE": "Эта запись больше недоступна.",
      "DELETE_RECORDING": {
        "BUTTON": "Удалить запись звонка",
        "TITLE": "Удалить запись звонка?",
        "DESCRIPTION": "Все записи этого звонка будут безвозвратно удалены с телефонной станции, восстановить их будет невозможно. Расшифровка и краткое содержание звонка сохранятся.",
        "CONFIRM": "Удалить",
        "SUCCESS": "Запись звонка удалена",
        "ERROR": "Не удалось удалить запись звонка. Повторите попытку."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Просмотреть на карте"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Отправить"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Это изображение больше недоступно.",
      "LOADING_FAILED": "Не удалось загрузить"
    }
  },
  "CONFIRM_EMAIL": "Проверка...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Добавить источник"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Нет элементов",
    "CURRENTLY_VIEWING_ACCOUNT": "Сейчас просматривается:",
    "SWITCH": "Переключить",
    "INBOX_VIEW": "Просмотр входящих сообщений",
    "CONVERSATIONS": "Диалоги",
    "INBOX": "Мои Входящие",
    "ALL_CONVERSATIONS": "Диалоги",
    "MENTIONED_CONVERSATIONS": "Упоминания",
    "PARTICIPATING_CONVERSATIONS": "Участвующие",
    "UNATTENDED_CONVERSATIONS": "Неотвеченные",
    "REPORTS": "Отчёты",
    "SETTINGS": "Настройки",
    "CONTACTS": "Контакты",
    "DATA_ASSISTANT": "Ассистент данных",
    "CAPTAIN": "Капитан",
    "CAPTAIN_ASSISTANTS": "Ассистенты",
    "CAPTAIN_DOCUMENTS": "Документы",
    "CAPTAIN_RESPONSES": "FAQ",
    "HOME": "Главная",
    "AGENTS": "Операторы",
    "AGENT_BOTS": "Боты",
    "AUDIT_LOGS": "Журнал аудита",
    "WHATSAPP_TEMPLATES": "Шаблоны WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Источники",
    "NOTIFICATIONS": "Уведомления",
    "CANNED_RESPONSES": "Шаблонные ответы",
    "INTEGRATIONS": "Интеграции",
    "PROFILE_SETTINGS": "Настройки профиля",
    "ACCOUNT_SETTINGS": "Настройки аккаунта",
    "APPLICATIONS": "Приложения",
    "LABELS": "Категории",
    "CUSTOM_ATTRIBUTES": "Пользовательские атрибуты",
    "AUTOMATION": "Автоматизация",
    "MACROS": "Макрос",
    "TEAMS": "Команды",
    "BILLING": "Платёж",
    "CUSTOM_VIEWS_FOLDER": "Папки",
    "CUSTOM_VIEWS_SEGMENTS": "Сегменты",
    "ALL_CONTACTS": "Все контакты",
    "TAGGED_WITH": "С метками",
    "NEW_LABEL": "Новая метка",
    "NEW_TEAM": "Новая команда",
    "NEW_INBOX": "Новые канал",
    "REPORTS_CONVERSATION": "Диалоги",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Онлайн чат",
    "SMS": "SMS",
    "CAMPAIGNS": "Кампании",
    "ONGOING": "Повторяющиеся",
    "ONE_OFF": "Единоразовые",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Бот",
    "REPORTS_AGENT": "Операторы",
    "REPORTS_LABEL": "Категории",
    "REPORTS_INBOX": "Электронная почта",
    "REPORTS_TEAM": "Команда",
    "REPORTS_PHONE": "Телефон",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Обзор",
    "WALLBOARD_QUEUES": "Очереди",
    "DATA_ASSISTANT_CHAT": "Чат",
    "DATA_ASSISTANT_REPORTS": "Отчёты",
    "NO_WAITING_CALLERS": "нет звонящих в ожидании",
    "WAITING_CALLERS": "{count} звонящих в ожидании",
    "SET_AVAILABILITY_TITLE": "Установить себя",
    "SET_YOUR_AVAILABILITY": "Настройте ваши рабочие часы",
    "AVAILABILITY_IMPERSONATING": "Заблокировано при входе от имени этого пользователя",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Пользовательские роли",
    "NEW_CONVERSATION": "Новый диалог",
    "DRAFT": "Черновик",
    "BETA": "Бета",
    "REPORTS_OVERVIEW": "Обзор",
    "REAUTHORIZE": "Срок действия вашего источника истек, пожалуйста, переподключите\n чтобы снова получать и отправлять сообщения",
    "HELP_CENTER": {
      "TITLE": "Центр поддержки",
      "ARTICLES": "Статьи",
      "CATEGORIES": "Категории",
      "LOCALES": "Locales",
      "SETTINGS": "Настройки",
      "DICTIONARY": "Словарь"
    },
    "CHANNELS": "Источники",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Отметить автоматически",
      "INFO_TEXT": "Позволить системе автоматически отмечать вас в автономном режиме, если вы не используете приложение или приборную панель.",
      "INFO_SHORT": "Автоматически отмечать оффлайн, когда вы не используете приложение."
    },
    "DOCS": "Открыть документацию"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Заблокированные домены и контакты",
    "DESCRIPTION": "Список заблокированных доменов электронной почты для этого аккаунта.",
    "NO_BLOCKED_DOMAINS": "Заблокированные домены не найдены.",
    "BLOCKED_CONTACTS_BTN": "Заблокированные контакты"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Платёж",
    "DESCRIPTION": "Управляйте подпиской здесь, обновите тарифный план и получите больше возможностей для вашей команды.",
    "CURRENT_PLAN": {
      "TITLE": "Текущий план",
      "PLAN_NOTE": "На данный момент вы подписаны на ** план{plan}** с **{quantity}** лицензиями",
      "SEAT_COUNT": "Количество мест",
      "RENEWS_ON": "Продление"
    },
    "VIEW_PRICING": "Посмотреть цены",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Управление подпиской",
      "DESCRIPTION": "Просматривайте ваши предыдущие счета, редактируйте платежные реквизиты или отмените подписку.",
      "BUTTON_TXT": "Перейти на платёжный портал"
    },
    "CAPTAIN": {
      "TITLE": "Капитан",
      "DESCRIPTION": "Управляйте использованием и кредитами для Captain AI.",
      "BUTTON_TXT": "Купить дополнительные кредиты",
      "DOCUMENTS": "Документы",
      "RESPONSES": "Ответы",
      "UPGRADE": "Captain недоступен в бесплатном тарифном плане, обновите его, чтобы получить доступ к ассистентам, copilot и другим функциям."
    },
    "CHAT_WITH_US": {
      "TITLE": "Нужна помощь?",
      "DESCRIPTION": "Вы сталкиваетесь с какими-либо проблемами при оплате? Мы здесь, чтобы помочь.",
      "BUTTON_TXT": "Пообщайтесь с нами"
    },
    "NO_BILLING_USER": "Ваш платёжный счёт настраивается. Пожалуйста, обновите страницу и повторите попытку."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ой! Мы не смогли найти ни одного аккаунта. Пожалуйста, создайте новый аккаунт, чтобы продолжить.",
    "NEW_ACCOUNT": "Новый аккаунт",
    "SELECTOR_SUBTITLE": "Создать новый аккаунт",
    "API": {
      "SUCCESS_MESSAGE": "Аккаунт создан",
      "EXIST_MESSAGE": "Аккаунт уже существует",
      "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Название компании",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Отправить",
      "CANCEL": "Отменить"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Показать все ярлыки",
    "TITLE": {
      "OPEN_CONVERSATION": "Открыть беседу",
      "RESOLVE_AND_NEXT": "Решить и перейти к следующему",
      "NAVIGATE_DROPDOWN": "Навигация в выпадающем списке",
      "RESOLVE_CONVERSATION": "Решить диалог",
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти к панели диалогов",
      "ADD_ATTACHMENT": "Добавить вложение",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти к панели контактов",
      "TOGGLE_SIDEBAR": "Переключить боковую панель",
      "GO_TO_REPORTS_SIDEBAR": "Перейти к боковой панели отчетов",
      "MOVE_TO_NEXT_TAB": "Переместить на следующую вкладку в списке диалогов",
      "GO_TO_SETTINGS": "Перейти к настройкам",
      "SWITCH_TO_PRIVATE_NOTE": "Переключиться на заметку",
      "SWITCH_TO_REPLY": "Переключиться на ответ",
      "TOGGLE_SNOOZE_DROPDOWN": "Вкл/выкл повтор",
      "AI_ASSIST_MENU": "Помощь ИИ",
      "AI_ASSIST_GRAMMAR": "Исправить грамматику",
      "AI_ASSIST_UNIFY_LANG": "Унифицировать язык сообщения"
    }
  }
}
